import { Self, Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input[toUpperCase]',
})
export class InputToUpperCaseDirective {
  constructor(@Self() private input: NgControl) {}

  @HostListener('input', ['$event']) onInput($event: InputEvent) {
    const target = $event.target as HTMLInputElement;
    const value = target.value;
    const result = value.toUpperCase();
    this.input?.control?.setValue(result);
  }
}
